<template>
<div class="group-work-countdown">
  <div>剩余</div>
  <div class="times">{{day}}</div>
  <div class="times">{{hour}}</div>
  <div class="times">{{min}}</div>
  <div class="times">{{second}}</div>
  <div>结束</div>
</div>
</template>
<script>
const dayTime = 24 * 60 * 60 * 1000
const hourTime = 60 * 60 * 1000
const minTime = 60 * 1000

export default {
  props: {
    times: {
      default: 8835622401
    }
  },
  mounted() {
    this.sourceTime = this.times
    this.initData(this.sourceTime)
  },
  data() {
    return {
      day: '',
      hour: '',
      min: '',
      second: ''
    }
  },
  methods: {
    initData(times) {
      this.day = this.formatterNum(Math.floor(times / dayTime))
      this.hour = this.formatterNum(Math.floor((times - this.day * dayTime) / hourTime))
      this.min = this.formatterNum(Math.floor((times - this.day * dayTime - this.hour * hourTime) / minTime))
      this.second = this.formatterNum(Math.floor((times - this.day * dayTime - this.hour * hourTime - this.min * minTime) / 1000))
      if (times > 0) {
        return setTimeout(this.update, 1000)
      }
    },
    formatterNum(val) {
      if (val < 10) {
        return `0${val}`
      } else {
        return val
      }
    },
    update() {
      this.sourceTime -= 1000
      if (this.sourceTime < 1000) {
        this.day = '00'
        this.hour = '00'
        this.min = '00'
        this.second = '00'
        window.location.reload()
        return
      }
      return this.initData(this.sourceTime)
    }
  }
}
</script>
<style lang="less" scoped>
.group-work-countdown {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 0.28rem;

  .times {
    width: 0.4rem;
    height: 0.4rem;
    background-color: #333333;
    color: #ffffff;
    text-align: center;
    line-height: 0.4rem;
    margin-right: 0.16rem;
    position: relative;
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
    color:rgba(255,255,255,1);
    &::before {
      content: '';
      position: absolute;
      right: -0.08rem;
      top: 50%;
      transform: translateX(50%) translateY(-50%);
      background: url('./img/time_spot.png') no-repeat;
      background-size: 100% 100%;
      width: 2px;
      height: 7px;
    }
  }

  .times:nth-of-type(2) {
    margin-left: 0.12rem;
  }
  .times:nth-of-type(5) {
    margin-right: 0.12rem;
    &::before {
      content: '';
      display: none;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/courseCenter/public/groupWork/_countdown.vue